import React, { useState, useEffect } from 'react';
import { Check, X, Clock } from 'lucide-react';

const RuleCard = ({ rule, isLast, onQuizPassed, quizPassed }) => {
  const [timeLeft, setTimeLeft] = useState(5);
  const [showQuiz, setShowQuiz] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    setTimeLeft(5);
    setShowQuiz(false);
    setSelectedAnswer(null);
    setShowError(false);
  }, [rule.id]);

  useEffect(() => {
    if (timeLeft > 0 && !quizPassed) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    } else if (timeLeft === 0 && !showQuiz && !quizPassed) {
      setShowQuiz(true);
    }
  }, [timeLeft, showQuiz, quizPassed]);

  const handleAnswer = (answer) => {
    setSelectedAnswer(answer);
    if (answer === rule.quiz.correctAnswer) {
      setShowError(false);
      onQuizPassed();
    } else {
      setShowError(true);
      setTimeout(() => {
        setSelectedAnswer(null);
        setShowError(false);
        setShowQuiz(false);
        setTimeLeft(5);
      }, 2000);
    }
  };

  return (
    <>
      <div className="text-center mb-8">
        <div className="text-6xl mb-4 animate-bounce">
          {rule.icon}
        </div>
        <h2 className="text-2xl font-bold text-white mb-4">
          Regla {rule.id}
        </h2>
        <h3 className="text-xl font-semibold text-yellow-500 mb-4">
          {rule.title}
        </h3>
        <p className="text-gray-300 leading-relaxed">
          {rule.description}
        </p>
      </div>

      {!quizPassed && (
        <>
          {timeLeft > 0 && !showQuiz && (
            <div className="flex flex-col items-center justify-center mb-8">
              <div className="flex items-center gap-2 text-gray-400">
                <Clock className="w-5 h-5" />
                <span>Lee la regla atentamente...</span>
              </div>
              <div className="mt-4 w-16 h-16 rounded-full border-4 border-yellow-500 flex items-center justify-center">
                <span className="text-2xl font-bold text-yellow-500">{timeLeft}</span>
              </div>
            </div>
          )}

          {showQuiz && (
            <div className="mb-8">
              <div className="bg-gray-800/50 rounded-xl p-6 border border-yellow-600/30">
                <p className="text-white text-center mb-6 text-lg font-medium">
                  {rule.quiz.question}
                </p>
                <div className="flex justify-center gap-4">
                  <button
                    onClick={() => handleAnswer(true)}
                    disabled={selectedAnswer !== null}
                    className={`px-8 py-3 rounded-xl font-semibold transition-all duration-300 ${
                      selectedAnswer === true
                        ? selectedAnswer === rule.quiz.correctAnswer
                          ? 'bg-green-500 text-white'
                          : 'bg-red-500 text-white'
                        : 'bg-gray-700 text-white hover:bg-gray-600'
                    }`}
                  >
                    Sí
                  </button>
                  <button
                    onClick={() => handleAnswer(false)}
                    disabled={selectedAnswer !== null}
                    className={`px-8 py-3 rounded-xl font-semibold transition-all duration-300 ${
                      selectedAnswer === false
                        ? selectedAnswer === rule.quiz.correctAnswer
                          ? 'bg-green-500 text-white'
                          : 'bg-red-500 text-white'
                        : 'bg-gray-700 text-white hover:bg-gray-600'
                    }`}
                  >
                    No
                  </button>
                </div>
                {showError && (
                  <div className="mt-4 flex items-center justify-center gap-2 text-red-400">
                    <X className="w-5 h-5" />
                    <span>Respuesta incorrecta. Vuelve a leer la regla.</span>
                  </div>
                )}
                {selectedAnswer === rule.quiz.correctAnswer && (
                  <div className="mt-4 flex items-center justify-center gap-2 text-green-400">
                    <Check className="w-5 h-5" />
                    <span>¡Correcto!</span>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}

      {quizPassed && (
        <div className="flex items-center justify-center mb-8">
          <div className="flex items-center gap-2 text-green-400">
            <Check className="w-5 h-5" />
            <span>Regla aceptada</span>
          </div>
        </div>
      )}
    </>
  );
};

export default RuleCard;